var z = Object.defineProperty;
var V = (r, e, t) => e in r ? z(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var m = (r, e, t) => V(r, typeof e != "symbol" ? e + "" : e, t);
import { observable as w, action as A, flow as j, makeObservable as k } from "mobx";
class H {
  constructor(e) {
    m(this, "agent");
    this.agent = e;
  }
  async fetchWells() {
    return (await this.agent.get("wells")).data;
  }
}
var F = /* @__PURE__ */ ((r) => (r[r.ACTIVE_GREEN = 0] = "ACTIVE_GREEN", r[r.ACTIVE_YELLOW = 1] = "ACTIVE_YELLOW", r[r.ACTIVE_RED = 2] = "ACTIVE_RED", r[r.COMPLETED = 3] = "COMPLETED", r))(F || {});
const B = [
  "Common_Pad",
  "Common_Rig",
  "Common_Brigade",
  "Common_Block",
  "Common_Field",
  "Common_Organization",
  "Common_Rig_Model"
];
function G(r, e) {
  const t = [], [s, n, d, f, I, b, C] = B.map(
    (a, i) => {
      var p, l, c, u, g, h, y, v, M, D, O, P, E, R;
      switch (a) {
        case "Common_Pad":
          return new Map(
            (l = (p = e[i]) == null ? void 0 : p.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? l : []
          );
        case "Common_Rig":
          return new Map(
            (u = (c = e[i]) == null ? void 0 : c.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? u : []
          );
        case "Common_Brigade":
          return new Map(
            (h = (g = e[i]) == null ? void 0 : g.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? h : []
          );
        case "Common_Rig_Model":
          return new Map(
            (v = (y = e[i]) == null ? void 0 : y.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? v : []
          );
        case "Common_Organization":
          return new Map(
            (D = (M = e[i]) == null ? void 0 : M.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? D : []
          );
        case "Common_Block":
          return new Map(
            (P = (O = e[i]) == null ? void 0 : O.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? P : []
          );
        case "Common_Field":
          return new Map(
            (R = (E = e[i]) == null ? void 0 : E.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? R : []
          );
      }
    }
  );
  return r.forEach((a) => {
    const i = s.get(a.padId);
    i || console.error("cannot find pad fow well", a.id, a.name);
    const p = i ? I.get(i.fieldId) : void 0;
    p || console.error("cannot find field fow well", a.id, a.name);
    const l = i ? f.get(i.blockId) : void 0;
    l || console.error("cannot find block fow well", a.id, a.name);
    const c = n.get(a.rigId);
    c || console.error("cannot find rig fow well", a.id, a.name);
    const u = c ? C.get(c.modelId) : void 0;
    u || console.error("cannot find rigModel fow well", a.id, a.name);
    const g = d.get(a.brigadeId);
    g || console.error("cannot find brigade fow well", a.id, a.name);
    const h = l ? b.get(l.organizationId) : void 0;
    h || console.error("cannot find organization fow well", a.id, a.name), t.push({
      ...a,
      pad: i,
      field: p,
      block: l,
      rig: c,
      rigModel: u,
      brigade: g,
      organization: h
    });
  }), t;
}
async function L(r, e) {
  try {
    const [t, s, ...n] = await e.loadObjects([
      "GOdashboard_Well",
      "Common_Well",
      ...B
    ]), d = (() => {
      var C;
      const f = [], I = new Map(r.map((a) => [a.id, a])), b = new Map((C = s == null ? void 0 : s.map((a) => [a.id, a])) != null ? C : []);
      return t == null || t.forEach((a) => {
        var c;
        const i = I.get(a.id);
        if (!i)
          return;
        const p = typeof a.data.ecosystemWellId == "number" ? a.data.ecosystemWellId : a.id, l = b.get(p);
        f.push({
          ...i,
          ...(c = l == null ? void 0 : l.data) != null ? c : {},
          ...a.data,
          createdAt: a.createdAt
        });
      }), f;
    })();
    return G(d, n);
  } catch (t) {
    return console.error(t), [];
  }
}
var N = Object.defineProperty, Y = Object.getOwnPropertyDescriptor, _ = (r, e, t, s) => {
  for (var n = s > 1 ? void 0 : s ? Y(e, t) : e, d = r.length - 1, f; d >= 0; d--)
    (f = r[d]) && (n = (s ? f(e, t, n) : f(n)) || n);
  return s && n && N(e, t, n), n;
};
class W {
  constructor(e, t) {
    m(this, "api");
    m(this, "directoriesService");
    m(this, "allWells", []);
    m(this, "isLoading", !1);
    m(this, "error", null);
    m(this, "loadPromise", null);
    m(this, "isLoaded", !1);
    this.api = e, this.directoriesService = t, k(this);
  }
  getWellById(e) {
    return this.allWells.find((t) => t.id === e);
  }
  updateWellStatus(e, t) {
    const s = this.getWellById(e);
    if (!s) {
      console.error("cannot find corresponding well with wellId", e);
      return;
    }
    s.status = t;
  }
  async *load(e) {
    if (!(e != null && e.force)) {
      if (this.loadPromise) {
        const n = await this.loadPromise;
        return yield, n;
      }
      if (this.isLoaded)
        return this.allWells;
    }
    this.isLoading = !0, this.error = null;
    const t = (async () => {
      try {
        const n = await this.api.fetchWells(), d = await L(n, this.directoriesService);
        return this.allWells = d, this.isLoaded = !0, d;
      } catch (n) {
        return this.error = n, console.error(n), [];
      } finally {
        this.isLoading = !1, this.loadPromise = null;
      }
    })();
    this.loadPromise = t;
    const s = await t;
    return yield, s;
  }
}
_([
  w.ref
], W.prototype, "allWells", 2);
_([
  w
], W.prototype, "isLoading", 2);
_([
  w.ref
], W.prototype, "error", 2);
_([
  A.bound
], W.prototype, "updateWellStatus", 1);
_([
  j.bound
], W.prototype, "load", 1);
export {
  B as D,
  F as W,
  H as a,
  W as b,
  L as e
};
//# sourceMappingURL=wells-data-service-CmeGFL-u.js.map
